/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import AnimationEffect from "./AnimationEffect";

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class RandomAnimationEffect extends AnimationEffect
{
    /** The animation name to play on the [[sp.Skeleton]]. */
    @property({ visible: false, override: true })
    protected _anim: string = '';

    @property([cc.String])
    protected animations: string[] = [];

    /** @hidden */
    protected prepareAnimations(): void
    {
        const animIndex: number = Math.round(Math.random() * (this.animations.length - 1));
        this._anim = this.animations[animIndex];

        super.prepareAnimations();
    }
}
